/**
 * JBIG2 encoder running in the browser (WebAssembly). The encoder itself is in jbig2Core.ts (shared with the API);
 * this file only fetches the wasm file the site ships. Built from jbig2enc (Apache-2.0) and Leptonica (BSD-2); the
 * recipe is in tools/jbig2-wasm.
 */
import wasmUrl from "./jbig2.wasm?url";
import { createJbig2, type Jbig2Encoder } from "./jbig2Core";

export { packBitmap, type Jbig2Encoder } from "./jbig2Core";

let cached: Promise<Jbig2Encoder> | null = null;

/** Loads the encoder once (about 110 KB over the wire). `source` is only for tests: the wasm bytes. */
export function loadJbig2(source?: BufferSource): Promise<Jbig2Encoder> {
  if (source) return createJbig2(source);
  if (cached) return cached;
  const p = (async () => {
    const res = await fetch(wasmUrl);
    if (!res.ok) throw new Error("Couldn't load the JBIG2 encoder");
    return createJbig2(await res.arrayBuffer());
  })();
  cached = p;
  p.catch(() => { cached = null; }); // a failed load can be tried again
  return p;
}
